import { css } from '@emotion/css';

export const coverImageStyles = css`
  background: linear-gradient(rgba(0, 0, 0, 0.44), rgba(0, 0, 0, 0.44));
`;
